import { Card, Row, Col } from "react-bootstrap";
import { HashLink as Link } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import Colors from "../../constants/Colors";
import BlurBlueDecorationSmall from "../../components/decorations/BlurBlueDecorationSmall";
import BlurOrangeDecorationSmall from "../../components/decorations/BlurOrangeDecorationSmall";

const Learn5gsection = () => {
  return (
    <div className="position-relative bg-opacity">
      <Decoration />
      <div>
        <div className="container spacing">
          <Learn5gTitle />
          <Learn5gCard />
        </div>
      </div>
    </div>
  );
};

const Learn5gTitle = ({ color = Colors.white }) => {
  const { t } = useTranslation();

  return (
    <div>
      <h1
        className="success-cases-title text-center fs-48 fw-semibold mb-5"
        style={{ color: color }}
      >
        {t('applications.title-home')}
      </h1>
      <h3
        className="success-cases-title text-center fs-24 fw-semibold mb-5"
        style={{ color: color }}
      >
        {t('applications.subtitle')}
      </h3>
    </div>
  );
};

const Learn5gCard = () => {
  const { t } = useTranslation();

  const ApplicactionData = t('applications.list');
  return (
    <div className="text-white">
      <Row className="d-flex justify-content-center text-center g-0 row-cols-1 row-cols-md-2 row-cols-lg-3">
        {
          ApplicactionData.map((topic, index) => {
            return (
              <Col key={index}>
                <div className="d-flex justify-content-center pb-5">
                  <Card
                    style={{
                      borderRadius: "15px",
                      height: "227px",
                      width: "223px",
                      background: "rgba(195, 195, 195, 0.16)",
                    }}
                  >
                    <Card.Body>
                      <div className="d-flex justify-content-center align-items-center pt-2 pb-3">
                        <div className="learn-5g-img-border d-flex justify-content-center align-items-center">
                          <img src={`${process.env.PUBLIC_URL}/images/applications/${topic.imgUrl}`} className="img-fluid" style={{ height: '48px', width: 'auto' }} alt="" />
                        </div>
                      </div>
                      <Card.Title className="fs-22 fw-medium">{topic.title}</Card.Title>
                      <span className="fs-13 fw-regular text-ellipsis d-block">{topic.description}</span>
                      <Link smooth to={`/apps/#${topic.hash}`} className='text-white fw-bold fonts-12'>
                        {t("applications.button")}
                      </Link>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            )
          })
        }
      </Row>
    </div>
  );
};

const Decoration = () => {
  return (
    <>
      <div
        className="position-absolute"
        style={{ top: "106.46px", left: "100px", zIndex: "-1" }}
      >
        <BlurBlueDecorationSmall />
      </div>
      <div
        className="position-absolute"
        style={{ top: "600px", right: "15%", zIndex: "-1" }}
      >
        <BlurOrangeDecorationSmall />
      </div>
    </>
  );
};

export default Learn5gsection;
